<script lang="ts">
import {defineComponent} from 'vue'
import MediaGalleryAsset from "@src/Resources/epim/Templates/MediaGallery/components/MediaGalleryAsset.vue";
import MediaGalleryNavigation from "@src/Resources/epim/Templates/MediaGallery/components/MediaGalleryNavigation.vue";
import GlobalModal from "@global/global-elements/global-modal/global-modal.vue";
import MediaGalleryAssetModal from "@src/Resources/epim/Templates/MediaGallery/components/MediaGalleryAssetModal.vue";
import {mapGetters} from "vuex";
import {MediaGalleryAssetType} from "@src/Resources/epim/Templates/MediaGallery/types/MediaGalleryAssetType";
import GlobalButton from "@global/global-elements/global-button/global-button.vue";
import GlobalLoadingOverlay from "@global/global-elements/global-loading-overlay/global-loading-overlay.vue";

export default defineComponent({
    name: "MediaGalleryList",
    components: {GlobalLoadingOverlay, GlobalButton, MediaGalleryAssetModal, GlobalModal, MediaGalleryNavigation, MediaGalleryAsset},
    data: () => {
        return {
            detail: "",
            waitForLoadMore: false
        }
    },
    computed: {
        ...mapGetters({
            assets: 'getAssets',
            totalAssets: 'getTotalAssets',
            hasRunningRequest: 'hasRunningRequest'
        }),
        loadMoreRequestIdentifier(): string {
            return 'searchAssets' + this.$store.state.mediaGallery.mode
        },
        getDetailAsset(): MediaGalleryAssetType|null {
            if (!this.assets || !this.detail) {
                return null
            }
            return this.assets.find((asset: MediaGalleryAssetType) => asset.id === this.detail)
        },
        detailIndex(): number {
            if (!this.assets || !this.detail) {
                return -1
            }
            return this.assets.findIndex((asset: MediaGalleryAssetType) => asset.id === this.detail)
        },
        disablePreviousDetail(): boolean {
            return !this.detail || this.detailIndex <= 0 || this.hasRunningRequest(this.loadMoreRequestIdentifier);
        },
        disableNextDetail(): boolean {
            return !this.detail || this.detailIndex >= this.totalAssets - 1 || this.hasRunningRequest(this.loadMoreRequestIdentifier);
        },
        isLoading(): boolean {
            return this.hasRunningRequest(this.loadMoreRequestIdentifier) || this.hasRunningRequest("collection") || this.hasRunningRequest("download")
        }
    },
    methods: {
        clearDetail() {
            this.detail = ""
        },
        showDetail(id: string) {
            this.detail = id
        },
        showPreviousDetail() {
            if (!this.disablePreviousDetail) {
                this.detail = this.assets[this.detailIndex - 1].id ?? ""
            }
        },
        showNextDetail() {
            if (!this.disableNextDetail) {
                const nextIndex = this.detailIndex + 1;
                if (this.assets.length <= nextIndex) {
                    const loadMore = this.$store.dispatch('searchAssets', true);
                    loadMore.then(() => {
                        if (this.$store.getters.getAssets.length > nextIndex) {
                            this.detail = this.assets[nextIndex].id ?? ""
                        }
                    });
                }
                else {
                    this.detail = this.assets[nextIndex].id ?? ""
                }
            }
        },
        keyupHandler(event: KeyboardEvent) {
            if (event.code === "ArrowLeft") {
                if (!this.disablePreviousDetail) {
                    this.showPreviousDetail();
                }
            }
            else if (event.code === "ArrowRight") {
                if (!this.disableNextDetail) {
                    this.showNextDetail();
                }
            }
            else if (event.code === "Escape") {
                // Prevent escape when loadMore is running. Otherwise the modal just opens again once loadmore is done
                if (!this.hasRunningRequest(this.loadMoreRequestIdentifier)) {
                    this.clearDetail();
                }
            }
        },

    },
    mounted() {
        window.addEventListener('keyup', this.keyupHandler);
    },
    beforeUnmount() {
        window.removeEventListener('keyup', this.keyupHandler);
    }
})
</script>

<template>
    <div class="container media-gallery-list">
        <global-loading-overlay :show-loading="isLoading">{{$t('mediaGallery.loadMore.loadingText')}}</global-loading-overlay>
        <div class="row">
            <div class="media-gallery-list__result-count col-12"><p>{{ totalAssets }}&nbsp;<span>{{ $t('mediaGallery.results.totalResults') }}</span></p><div class="media-gallery-list__decoration"></div></div>
            <div v-if="assets.length === 0" class="media-gallery-list__no-result col-12">
                <p>{{$t('mediaGallery.results.noResult')}}</p>
            </div>
            <div v-for="asset in assets" class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
                <media-gallery-asset :asset="asset" :key="asset.id" @showDetail="showDetail"/>
            </div>
        </div>
        <global-modal v-if="getDetailAsset" :lock-scrolling="true" @close="clearDetail" :over-menu="true">
            <template v-slot:body>
                <media-gallery-asset-modal :asset="getDetailAsset" v-touch:swipe.right="showPreviousDetail" v-touch:swipe.left="showNextDetail">
<!--                    "Modal" im "Modal" und beide haben pagination slots. Win-Win! :-)-->
                    <template v-slot:pagination>
                        <global-button icon="arrow-left" theme="ghost" :disabled="disablePreviousDetail" @click="showPreviousDetail"/>
                        <span>{{ detailIndex + 1 }} {{$t('mediaGallery.loadMore.xOfY')}} {{ totalAssets }}</span>
                        <global-button icon="arrow-right" theme="ghost" :disabled="disableNextDetail" @click="showNextDetail" />
                        <global-loading-overlay :show-loading="hasRunningRequest(loadMoreRequestIdentifier)">{{$t('mediaGallery.loadMore.loadingText')}}</global-loading-overlay>
                    </template>
                </media-gallery-asset-modal>
            </template>
        </global-modal>
    </div>
</template>

<style scoped lang="scss">

</style>
